// extracted by mini-css-extract-plugin
export default {"checkBoxList":"CheckBoxList_checkBoxList__rSFEA","requiredSymbol":"CheckBoxList_requiredSymbol__aB506"};